import { TAddFamilyMembersFormValues } from '@/common/containers/Dashboard/Insurance/InsuranceAddMembersPage/components/AddMemberCardForm/AddMemberCardForm.schema';
import { TInsurancePlanSimulation } from '@/common/integrations/menhir/employee/insurance/insurance.types';

export const removeMemberFromSimulation = (
  simulation: TInsurancePlanSimulation,
  member: TAddFamilyMembersFormValues['members'][number]
): TInsurancePlanSimulation => {
  const updatedPersons = simulation.persons.map((person) => {
    if (person.id === member.memberId) {
      return { ...person, selected: false };
    }
    return person;
  });

  return {
    ...simulation,
    persons: updatedPersons,
  };
};
